import React, { useState } from 'react';
import { Popup } from 'antd-mobile';

const sorts = [
  { sort: 'hot',             text: '热门交易' },
  { sort: 'havebeenplaying', text: '最近在玩' },
  { sort: 'publish',         text: '最新发布' },
  { sort: 'effective',       text: '性价比高' },
  { sort: 'asc',             text: '价格升序' },
  { sort: 'desc',            text: '价格降序' },
];

const devices = [
  { device: '0', text: '双端' },
  { device: '2', text: '苹果' },
  { device: '1', text: '安卓' },
];

/**
 * props:
 *   visible    bool
 *   onClose    fn
 *   tmpFilter  object   { sort, device, minPrice, maxPrice }
 *   onConfirm  fn(filter)   — 点确定时回调，传出最终 filter
 */
export default function TradeListFilter({ visible, onClose, tmpFilter: initFilter, onConfirm }) {
  const [local, setLocal] = useState(initFilter ?? { device: '0' });

  // 每次弹框打开时同步外部最新值
  React.useEffect(() => {
    if (visible) setLocal(initFilter ?? { device: '0' });
  }, [visible]);

  const handleReset = () => {
    setLocal({ sort: 2, device: '0', minPrice: '', maxPrice: '' });
  };

  const handleConfirm = () => {
    onConfirm?.(local);
    onClose?.();
  };

  const priceMin = (e) => setLocal({ ...local, minPrice: e.target.value.replace(/[^\d]/, '') });
  const priceMax = (e) => setLocal({ ...local, maxPrice: e.target.value.replace(/[^\d]/, '') });

  return (
    <Popup
      visible={visible}
      onMaskClick={onClose}
      position="bottom"
      bodyStyle={{ borderRadius: '16px 16px 0 0', paddingBottom: 'env(safe-area-inset-bottom)' }}
    >
      <div className="tlf-container">
        {/* 排序方式 */}
        <div className="tlf-section-title">排序方式</div>
        <div className="tlf-options">
          {sorts.map((item, i) => (
            <div
              key={i}
              className={'tlf-option' + (i === local.sort ? ' active' : '')}
              onClick={() => setLocal({ ...local, sort: i })}
            >
              {item.text}
            </div>
          ))}
        </div>

        {/* 设备 */}
        <div className="tlf-section-title">设备</div>
        <div className="tlf-options">
          {devices.map((item, i) => (
            <div
              key={i}
              className={'tlf-option' + (i == local.device ? ' active' : '')}
              onClick={() => setLocal({ ...local, device: i })}
            >
              {item.text}
            </div>
          ))}
        </div>

        {/* 价格区间 */}
        <div className="tlf-section-title">价格区间</div>
        <div className="tlf-prices">
          <input
            className="tlf-price-input"
            type="number"
            placeholder="最低价格"
            value={local.minPrice ?? ''}
            onChange={priceMin}
          />
          <span className="tlf-price-sep">——</span>
          <input
            className="tlf-price-input"
            type="number"
            placeholder="最高价格"
            value={local.maxPrice ?? ''}
            onChange={priceMax}
          />
        </div>

        {/* 操作按钮 */}
        <div className="tlf-operate">
          <button className="tlf-btn tlf-btn-reset" onClick={handleReset}>重置</button>
          <button className="tlf-btn tlf-btn-confirm" onClick={handleConfirm}>确定</button>
        </div>
      </div>
    </Popup>
  );
}
